/** 길드 건물의 공개 상태 표시. 계산된 서버 효과를 다시 게임 규칙으로 계산하지 않는다. */
import { S, esc } from '../core/state.js';
import { guildInteger, guildMoneyText } from './guild-money.js';
import { levelLabel } from '../core/level-label.js';

// UNI-Q217 — 공성 건물 둘을 더했다. 서버 `GUILD_BUILDING_DEFS` 의 stat 과 이름이 같아야 한다(빠지면 「길드 효과」로 뜬다)
export const GUILD_EFFECT_NAMES = { damage: '추가 피해', attackSpeed: '공격 속도', maxHp: '최대 체력', defense: '방어력', capacity: '무게 한도',
  siegeStructHp: '공성전 우리 구조물 체력', siegeTowerDmg: '공성전 우리 방어탑 피해' };

/** 작은 일반 수는 간결하게, JS 표현 범위를 벗어난 서버 문자열은 그대로 보존한다. */
export function guildEffectText(value) {
  const text = String(value ?? '0');
  if (!/^\d+(?:\.\d+)?(?:e[+-]?\d+)?$/i.test(text)) return '—';
  const n = Number(text);
  if (!Number.isFinite(n) || (n === 0 && /[1-9]/.test(text))) return text;
  return n.toLocaleString('ko-KR', { maximumSignificantDigits: 4 });
}

/** 오직 진행 표시만 0..10000으로 축소한다. 원본 비용/레벨/자금은 큰 정수 문자열이다. */
export function guildBuildingProgress(building) {
  const cost = guildInteger(building.nextCost), funded = guildInteger(building.funded);
  return { value: cost ? Number((funded < cost ? funded : cost) * 10000n / cost) : 0,
    needed: String(cost > funded ? cost - funded : 0n) };
}

/** 승급마다 개인 원장을 다시 읽지 않는다. 내 기여는 마지막 확정 조회값을 보존한다. */
export function applyGuildBuildings(message) {
  if (message.guildId !== S.guild?.me?.guild?.id || !Array.isArray(message.buildings) || !S.guild?.economy) return false;
  const incoming = new Map(message.buildings.map((b) => [b.id, b]));
  S.guild.economy.buildings = (S.guild.economy.buildings || []).map((old) => {
    const next = incoming.get(old.id);
    if (!next || guildInteger(next.level) < guildInteger(old.level)) return old;
    return { ...old, ...next, myContribution: old.myContribution };
  });
  return true;
}

/** Read-only operator view. Raw account keys and editable balance controls do not belong here. */
export function guildAdminBuildings(guild, upgrades) {
  const rows = (upgrades || []).filter((r) => r.guild_id === guild.id);
  return '<details class="admguildproject"><summary>건물·승급 원장</summary>'
    + (guild.buildings || []).map((b) => `<div><b>${esc(b.name)} · Lv.${levelLabel(b.level)}</b>`
      + `<p>건설 기금 ${guildMoneyText(b.funded)} / ${guildMoneyText(b.nextCost)} 은화</p>`
      + (b.effect ? `<small>${esc(GUILD_EFFECT_NAMES[b.effect.stat] || '효과')} +${esc(guildEffectText(b.effect.current))}${b.effect.unit === '%' ? '%' : ''}</small>` : '')
      + '</div>').join('')
    + '<h4>최근 건설 지출</h4>'
    + (rows.length ? rows.map((r) => `<p>${esc(guild.buildings?.find((b) => b.id === r.building)?.name || r.building)} `
      + `Lv.${levelLabel(r.levelBefore)} → ${levelLabel(r.levelAfter)} · ${guildMoneyText(r.spent)} 은화<br>`
      + `<small>세계 ${guildMoneyText(r.worldN)} · ${esc(new Date(r.at * 1000).toLocaleString('ko-KR'))}</small></p>`).join('')
      : '<p>최근 건물 승급 기록이 없다.</p>') + '</details>';
}
